/* istanbul ignore file */
import { RouterProvider } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import { theme } from "@covertree/theme";

import { store } from "@redux/store";
import { router } from "@routing/router";

export default function App() {
  return (
    <Provider store={store}>
      <ToastContainer hideProgressBar />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router()} />
      </ThemeProvider>
    </Provider>
  );
}
